<ng-container *ngIf="uploadInProgress then uploadingRef else defaultRef"></ng-container>

<ng-template #uploadingRef>
    <div *ngFor="let file of selectedFilesList" class="uploading">
        <img class="loader" src="/assets/img/loader.gif" alt="Loader">
        <div class="file-info">Please wait while {{ file.name }} is processing.</div>
    </div>
    <div *ngIf="isUploadingWarning" class="warning warning__uploading">File is uploading</div>
</ng-template>

<ng-template #defaultRef>
    <div *ngIf="maxFilesCount > uploadedFiles.length"
         class="drag-area"
         [class.file-required]="isRequiredWarning"
         uiDragNDrop
         (onFilesDrop)="handleFiles($event)">

        <h4 class="uploader-title">
            {{ areaTitle }}
            <label>
                <input type="file"
                       #fileInput
                       tabindex="0"
                       [multiple]="maxFilesCount > 1 ? true : null"
                       [accept]="acceptedExtensions"
                       (change)="handleFiles($event.srcElement.files)">
                <span>browse</span>
            </label>
        </h4>

        <ng-container *ngIf="customRestrictions then customRestrictionsRef else defaultRestrictionsRef"></ng-container>
        <span *ngIf="!isAttachment" style="font-size: 12px !important;
        line-height: 20px !important;
        color: #53565a!important;
        cursor: default !important;">The image should be at least 800 pixels</span>
        <ng-template #defaultRestrictionsRef>
            <div class="restrictions">
                You can add file with max size - {{ maxSizePerFileConverted }} Mb<br/>
                Supported format{{ resolvedExtensions.length > 1 ? 's' : '' }}: {{ resolvedExtensions.join(', ') }}<br/>
                <ng-container *ngIf="recommendedDimensions.isImage">
                    Recommended dimensions: {{ recommendedDimensions.value }}
                </ng-container>
            </div>
        </ng-template>
        <ng-template #customRestrictionsRef>
            <div class="restrictions" [innerHtml]="customRestrictions | safe: 'html'"></div>
        </ng-template>
    </div>

    <div *ngIf="isRequiredWarning" class="warning warning__required">Required</div>

    <ng-container *ngIf="uploadedFiles.length">
        <div class="attached">Uploaded file</div>
        <div class="uploaded-file" *ngFor="let file of uploadedFiles; let index = index">
            <div class="file-name">{{ file.name }}</div>
            <div class="file-size">{{ file.size ? file.size : fileSize | fileSize }}</div>
            <i [class]="deleteIcon" (click)="deleteFile(index)" (keydown.enter)="deleteFile(index)" tabindex="0" role="button"></i>
        </div>

    </ng-container>
</ng-template>
